import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { MODULES, SETTINGS_MODULE } from "@/lib/modules";
import { useApp } from "@/context/AppContext";
import { PanelLeftClose, PanelLeftOpen } from "lucide-react";

export function SubSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { can } = useApp();
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("iris-subnav") === "1");

  const toggle = () => setCollapsed((c) => { localStorage.setItem("iris-subnav", c ? "0" : "1"); return !c; });

  const isSettings = location.pathname.startsWith("/settings") || location.pathname === "/profile";
  const activeKey = isSettings ? "settings" : (location.pathname === "/" ? "dashboard" : location.pathname.split("/")[1]);
  const mod = isSettings ? SETTINGS_MODULE : MODULES.find((m) => m.key === activeKey);

  if (!mod || !mod.sub) return null;
  const items = mod.sub.filter((s) => !s.action || can(mod.key, s.action));

  if (collapsed) {
    return (
      <div className="flex h-screen w-8 shrink-0 items-start justify-center border-r border-border bg-card pt-4">
        <button data-testid="subnav-expand" onClick={toggle} className="text-muted-foreground hover:text-foreground" title="Expand">
          <PanelLeftOpen className="h-4 w-4" />
        </button>
      </div>
    );
  }

  return (
    <aside className="flex h-screen w-56 shrink-0 flex-col border-r border-border bg-card">
      <div className="flex items-center justify-between px-5 py-5">
        <h2 className="font-display text-[15px] font-semibold text-foreground">{mod.label}</h2>
        <button data-testid="subnav-collapse" onClick={toggle} className="text-muted-foreground hover:text-foreground" title="Collapse">
          <PanelLeftClose className="h-4 w-4" />
        </button>
      </div>
      <nav className="flex-1 space-y-1 px-3">
        {items.map((s) => {
          const active = location.pathname === s.path || (s.path !== "/" && location.pathname.startsWith(s.path));
          return (
            <button key={s.path} data-testid={`subnav-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => navigate(s.path)}
              className={cn("w-full rounded-lg px-3 py-2 text-left text-[13px] font-medium transition-colors",
                active ? "bg-accent text-accent-foreground" : "text-muted-foreground hover:bg-muted hover:text-foreground")}>
              {s.label}
            </button>
          );
        })}
      </nav>
    </aside>
  );
}
